import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  /** 어느 경계에서 터졌는지 로그로 구분하기 위한 이름 */
  label?: string;
}

interface State {
  hasError: boolean;
}

/**
 * 렌더 중 던져진 예외를 잡아 그 자리만 대체 UI 로 바꾼다.
 *
 * 경계가 없으면 React 는 트리 전체를 언마운트해 페이지가 백지가 된다(게시글 19번
 * 사고가 정확히 그랬다). 경계는 **감싸는 범위가 좁을수록 좋다** — 본문이 깨져도
 * 제목·첨부·댓글은 살아남아야 한다. 그래서 위험한 곳(본문 등)은 가까이서 감싸고,
 * 앱 최상단에는 나머지를 받아낼 마지막 그물만 둔다.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`[${this.props.label ?? "ErrorBoundary"}] 렌더링 실패:`, error, errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <p style={{ padding: "1rem", color: "#888" }}>
          내용을 표시할 수 없습니다.
        </p>
      );
    }

    return this.props.children;
  }
}
